<template>
  <section class="flex flex-col gap-5 px-3 mt-0 mb-10">
    <div
      v-if="keys && keys.length !== 0"
      class="flex flex-col gap-3 bg-white rounded-md shadow-md border-b-4 border-h-primary-700 p-5 py-3"
    >
      <p class="font-bold text-neutral-800 text-[16px]">
        {{
          $t("labels.generic", {
            pt: "Clique nas palavras-chave e veja vídeos relacionados",
            en: "Click on keywords and watch related videos",
          })
        }}
      </p>
      <div class="flex flex-wrap items-center text-h-primary-500 gap-5">
        <button
          v-for="(item, i) in keys"
          :key="i"
          class="bg-h-primary-200 rounded-[1.2rem] px-2 py-1 border text-sm md:text-sm font-[600] transition-all hover:scale-95 hover:opacity-80"
          @click="openCrawler(item.keyword)"
        >
          <p class="text-[12px]">
            {{ item.keyword }}
          </p>
        </button>
      </div>
    </div>

    <div v-if="transcripts && transcripts.length !== 0" class="bg-red-50">
      <Accordion class="accordion-crawler-custom" :lazy="true" :activeIndex="0">
        <AccordionTab>
          <template #header>
            <p class="font-bold text-neutral-800 text-[16px]">
              {{
                $t("labels.generic", {
                  pt: "Ver transcrição do vídeo",
                  en: "View video transcript",
                })
              }}
            </p>
          </template>
          <div class="h-96 overflow-auto scroll-style">
            <div
              v-for="(item, i) in transcripts"
              :key="i"
              @click.prevent="onClickDuration(item.startTime)"
            >
              <div
                class="border-b flex items-center w-full gap-3 hover:bg-h-secondary-50 transition-all cursor-pointer"
              >
                <div class="flex items-center gap-1 p-3 font-bold">
                  <p>
                    {{ duration(item.startTime) }}
                  </p>
                  <p>-</p>
                  <p>{{ duration(item.endTime) }}</p>
                </div>
                <div class="w-full py-5 px-2 font-[600] text-lg">
                  <p>{{ item.transcript }}</p>
                </div>
              </div>
            </div>
          </div>
        </AccordionTab>
      </Accordion>
    </div>
  </section>

  <Crawler
    v-if="showModal"
    @onClose="onCloseCrawler"
    :keyword="keyword"
    :transcriptId="transcriptId"
  />
</template>

<script lang="ts">
import { QueryParams } from "@/models/query-params.model";
import moment from "moment";
import { defineAsyncComponent, defineComponent, PropType } from "vue";
import { TrancriptsService } from "./transcripts.service";

const Crawler = defineAsyncComponent(
  () => import("@/views/Crawler/crawler.vue")
);

export default defineComponent({
  name: "transcripts",
  emits: ["onNeedsToPause", "onClickDuration"],
  components: { Crawler },
  props: {
    material: {
      type: Object as PropType<any>,
    },
  },
  computed: {
    service(): TrancriptsService {
      return new TrancriptsService();
    },
  },
  data() {
    return {
      keys: [] as any[],
      transcripts: [] as any[],
      showModal: false as boolean,
      keyword: "" as string,
      time: 0 as number,
      transcriptId: "" as string,
    };
  },
  mounted() {
    if (this.material?.file?.transcriptId) {
      this.getKeywordsFromCrawler();
      this.getTranscriptsFromCrawler();
    }
  },
  methods: {
    getKeywordsFromCrawler(): void {
      let params: Omit<QueryParams, "page" | "size"> = {
        keyword: true,
        quantity: 10,
      };

      this.service.keywords.subscribe({
        next: (response) => {
          this.keys = response;
        },
      });
      this.service.getKeywords(this.material?.file?.transcriptId, params);
    },
    getTranscriptsFromCrawler(): void {
      let params: Omit<QueryParams, "page" | "size"> = {
        transcript: true,
        startTime: true,
        endTime: true,
      };

      this.service.transcripts.subscribe({
        next: (response) => {
          this.transcripts = response;
        },
      });
      this.service.getTranscripts(this.material?.file?.transcriptId, params);
    },
    duration(sec: number): any {
      return moment.utc(sec * 1000).format("mm:ss");
    },
    onClickDuration(value: any): void {
      this.time = value;
      this.$emit("onClickDuration", value);
      window.scrollTo(0, 0);
    },
    onNeedsToPause(value: boolean): void {
      this.$emit("onNeedsToPause", value);
    },
    openCrawler(keyword: string): void {
      this.showModal = true;
      this.onNeedsToPause(true);
      this.keyword = keyword;
      this.transcriptId = this.material?.file?.transcriptId;
    },
    onCloseCrawler(value: boolean = false): void {
      this.showModal = value;
      this.keyword = "";
    },
  },
});
</script>
